module.exports = __webpack_public_path__ + "img/niteroica.83276539.png";